<template>
  <Layout>
    <McButtonBack href="/report" :query="{ domain: 'fleet' }" class="mt-2 me-3 mb-4 float-end" />

    <CustomReport v-if="!isLoading" :id="uuid" :link="link" />
  </Layout>
</template>

<script>
import McButtonBack from '@/components/McButtonBack'
import Layout from '@/router/layouts/main'
import { getCustomReportById } from '@/services/rest-api-identity/lib/metabase/custom.js'
import CustomReport from './CustomReport.vue'

export default {
  components: {
    Layout,
    McButtonBack,
    CustomReport,
  },

  data() {
    return {
      isLoading: true,
      link: '',
      uuid: '',
    }
  },
  mounted() {
    this.getCustomReportById(this.$route.params.id)
  },

  methods: {
    async getCustomReportById(id) {
      const res = await getCustomReportById(id)
      this.link = res.data.embed_link
      this.uuid = res.data.uuid

      setTimeout(() => {
        this.isLoading = false
      }, 500)
    },
  },
}
</script>
